import { render, staticRenderFns } from "./Nucafe.vue?vue&type=template&id=5b7f42e0&scoped=true&"
import script from "./Nucafe.vue?vue&type=script&lang=js&"
export * from "./Nucafe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7f42e0",
  null
  
)

export default component.exports